const messages = {
  pt: {
    translations: {
      signup: {
        title: 'Cadastre-se',
        toasts: {
          success: 'Usuário criado com sucesso! Faça seu login!!!.',
          fail: 'Erro ao criar usuário. Verifique os dados informados.'
        },
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha'
        },
        buttons: {
          submit: 'Cadastrar',
          login: 'Já tem uma conta? Entre!'
        }
      },
      login: {
        title: 'Login',
        accessDeniedModalTitle: 'Acesso não permitido',
        form: {
          email: 'Email',
          password: 'Senha'
        },
        buttons: {
          submit: 'Entrar',
          register: 'Não tem um conta? Cadastre-se!'
        }
      },
      companies: {
        title: 'Cadastrar Empresa',
        form: {
          name: 'Nome da Empresa',
          plan: 'Plano',
          token: 'Token',
          submit: 'Cadastrar',
          success: 'Empresa criada com sucesso!'
        }
      },
      auth: {
        toasts: {
          success: 'Login efetuado com sucesso!',
          pushPermissionDenied:
            'Permissão de notificações bloqueada no navegador. Ative-a para receber alertas de novas mensagens.',
          pushError: 'Erro ao ativar notificações push.'
        },
        token: 'Token'
      },
      dashboard: {
        charts: {
          perDay: {
            title: 'Atendimentos hoje: '
          }
        }
      },
      connections: {
        title: 'Conexões',
        toasts: {
          deleted: 'Conexão com o WhatsApp excluída com sucesso!'
        },
        confirmationModal: {
          deleteTitle: 'Deletar',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida.',
          disconnectTitle: 'Desconectar',
          disconnectMessage:
            'Tem certeza? Você precisará ler o QR Code novamente.'
        },
        buttons: {
          add: 'Adicionar WhatsApp',
          disconnect: 'desconectar',
          tryAgain: 'Tentar novamente',
          qrcode: 'QR CODE',
          newQr: 'Novo QR CODE',
          connecting: 'Conectando'
        },
        toolTips: {
          disconnected: {
            title: 'Falha ao iniciar sessão do WhatsApp',
            content:
              'Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code'
          },
          qrcode: {
            title: 'Aguardando leitura do QR Code',
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão"
          },
          connected: {
            title: 'Conexão estabelecida!'
          },
          timeout: {
            title: 'A conexão com o celular foi perdida',
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code"
          },
          refresh: {
            title: 'Refazer conexão',
            content:
              'Faz uma tentativa de reconectar sem a necessidade de gerar um novo QRCode'
          },
          disconnect: {
            title: 'Desconectar',
            content:
              'Desconecta do numero atual, será necessario gerar um novo QRCode para fazer a conexão novamente'
          },
          scan: 'Ler QR Code',
          newQr: {
            title: 'Gerar novo QR Code',
            content:
              'Clique para gerar um novo QR Code e refazer a conexão com o WhatsApp'
          },
          retry: {
            title: 'Tentar novamente',
            content:
              'Clique para tentar iniciar a sessão novamente com o WhatsApp'
          },
          passkey: {
            title: 'Autenticação por passkey necessária',
            content:
              'Clique no botão de passkey e use a extensão do navegador para capturar a sessão autenticada do WhatsApp Web.'
          },
          resetPasskey: 'Redefinir sessão passkey'
        },
        table: {
          name: 'Nome',
          status: 'Status',
          lastUpdate: 'Última atualização',
          default: 'Padrão',
          actions: 'Ações',
          session: 'Sessão'
        }
      },
      internalChat: {
        title: 'Chat Interno'
      },
      whatsappModal: {
        title: {
          add: 'Nova Conexão',
          edit: 'Editar Conexão'
        },
        form: {
          name: 'Nome',
          default: 'Padrão'
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar'
        },
        success: 'WhatsApp salvo com sucesso.'
      },
      qrCode: {
        message: 'Leia o QrCode para iniciar a sessão',
        extensionHint: 'Autenticar pelo WhatsApp Web',
        startCapture: 'Capturar sessão do WhatsApp Web',
        installExtension: 'Instalar extensão de captura'
      },
      passkeyModal: {
        title: 'Extensão de captura do WhatsApp Web',
        instructions:
          'Use a extensão do navegador para capturar a sessão autenticada do WhatsApp Web e enviá-la para o servidor.',
        connectorNotFound:
          'Extensão não detectada. Instale a extensão de captura passkey e recarregue a página.',
        connectorReady:
          'Extensão detectada. Clique abaixo para se autenticar pelo WhatsApp Web.',
        startCapture: 'Iniciar captura',
        waitingForCapture: 'Aguardando captura da sessão do WhatsApp Web…',
        existingSession: 'O WhatsApp Web já possui uma sessão para {{number}}.',
        captureExisting: 'Capturar esta sessão',
        clearAndContinue: 'Limpar sessão local e continuar',
        importSent: 'Sessão capturada e enviada com sucesso.',
        importError: 'Falha na captura: {{reason}}.',
        missingToken: 'Token de captura ausente. Recarregue a página.',
        downloadExtension: 'Baixar extensão de captura',
        installInstructions: 'Como instalar',
        hideInstructions: 'Ocultar instruções',
        instructionsIntro:
          'Siga os passos abaixo para instalar a extensão:',
        installStep1: 'Baixe o arquivo ZIP da extensão.',
        installStep2: 'Extraia o ZIP em uma pasta no seu computador.',
        installStep3: 'Abra o Google Chrome e acesse chrome://extensions/.',
        installStep4:
          'Ative o modo de desenvolvedor usando a chave no canto superior direito.',
        installStep5: 'Clique em "Carregar sem compactação".',
        installStep6:
          'Selecione a pasta extraída que contém os arquivos da extensão.',
        installStep7: 'A extensão está instalada e pronta para uso.',
        installStep8:
          'Atualize esta página com F5 e tente conectar novamente.'
      },
      contacts: {
        title: 'Contatos',
        files: 'Arquivos de Contatos',
        searchFiles:
          'Pesquisar arquivos por contato, número ou nome do arquivo...',
        noFiles: 'Nenhum arquivo encontrado',
        noContactsAvailable: 'Nenhum contato disponível',
        typeToSearchContact: 'Digite para pesquisar contato...',
        addFile: 'Adicionar Arquivo',
        addFileModal: 'Adicionar Arquivo ao Contato',
        selectContactLabel: 'Selecione um contato',
        selectFileLabel: 'Selecione um arquivo',
        selectContact: 'Por favor, selecione um contato',
        selectFile: 'Por favor, selecione um arquivo',
        addFileSuccess: 'Arquivo adicionado com sucesso!',
        deleteFileTitle: 'Confirmar exclusão',
        confirmDeleteFile: 'Tem certeza que deseja deletar este arquivo?',
        deleteFileSuccess: 'Arquivo excluído com sucesso!',
        fileName: 'Nome do Arquivo',
        toasts: {
          deleted: 'Contato excluído com sucesso!'
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Deletar ',
          importTitlte: 'Importar contatos',
          deleteMessage:
            'Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.',
          importMessage: 'Deseja importar todos os contatos do telefone?'
        },
        buttons: {
          import: 'Importar Contatos',
          add: 'Adicionar Contato'
        },
        table: {
          name: 'Nome',
          whatsapp: 'WhatsApp',
          email: 'Email',
          actions: 'Ações'
        }
      },
      contactModal: {
        title: {
          add: 'Adicionar contato',
          edit: 'Editar contato'
        },
        form: {
          mainInfo: 'Dados do contato',
          extraInfo: 'Informações adicionais',
          name: 'Nome',
          number: 'Número do Whatsapp',
          email: 'Email',
          extraName: 'Nome do campo',
          extraValue: 'Valor',
          disableBot: 'Desabilitar chatbot',
          defaultQueue: 'Departamento Padrão'
        },
        buttons: {
          addExtraInfo: 'Adicionar informação',
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar'
        },
        success: 'Contato salvo com sucesso.'
      },
      queueModal: {
        title: {
          add: 'Novo Bot',
          edit: 'Editar Bot'
        },
        form: {
          name: 'Nome',
          color: 'Cor',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          ratingMessage: 'Mensagem de avaliação',
          transferMessage: 'Mensagem de Transferência',
          pendingTicketWhatsappNotification:
            'Enviar aviso de atendimento pendente por WhatsApp aos usuários do departamento',
          token: 'Token'
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          attach: 'Anexar Arquivo'
        },
        serviceHours: {
          dayWeek: 'Dia da semana',
          startTimeA: 'Hora Inicial - Turno A',
          endTimeA: 'Hora Final - Turno A',
          startTimeB: 'Hora Inicial - Turno B',
          endTimeB: 'Hora Final - Turno B',
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo'
        }
      },
      userModal: {
        title: {
          add: 'Adicionar usuário',
          edit: 'Editar usuário'
        },
        form: {
          name: 'Nome e Sobrenome',
          email: 'Email',
          password: 'Senha',
          profile: 'Perfil'
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar'
        },
        success: 'Usuário salvo com sucesso.'
      },
      scheduleModal: {
        title: {
          add: 'Novo Agendamento',
          edit: 'Editar Agendamento'
        },
        form: {
          body: 'Mensagem',
          contact: 'Contato',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          saveMessage: 'Salvar Mensagem no Ticket'
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar'
        },
        success: 'Agendamento salvo com sucesso.'
      },
      tagModal: {
        title: {
          add: 'Nova Tag',
          edit: 'Editar Tag',
          addKanban: 'Nova Lane',
          editKanban: 'Editar Lane'
        },
        form: {
          name: 'Nome',
          color: 'Cor',
          kanban: 'Kanban'
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar'
        },
        success: 'Tag salvo com sucesso.',
        successKanban: 'Lane salva com sucesso.'
      },
      chat: {
        noTicketMessage: 'Selecione um atendimento para começar a conversar.'
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: 'ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO',
          titleFileList: 'Lista de arquivo(s)'
        }
      },
      ticketsManager: {
        buttons: {
          newTicket: 'Novo'
        }
      },
      ticketsQueueSelect: {
        placeholder: 'Departamentos'
      },
      tickets: {
        toasts: {
          deleted: 'O atendimento que você estava foi deletado.'
        },
        notification: {
          message: 'Mensagem de'
        },
        tabs: {
          open: { title: 'Abertas' },
          closed: { title: 'Resolvidos' },
          groups: { title: 'Grupos' },
          search: { title: 'Busca' }
        },
        search: {
          placeholder: 'Buscar atendimento e mensagens'
        },
        buttons: {
          showAll: 'Todos'
        }
      },
      transferTicketModal: {
        title: 'Transferir Ticket',
        fieldLabel: 'Digite para buscar usuários',
        fieldQueueLabel: 'Transferir para departamento',
        fieldQueuePlaceholder: 'Selecione um departamento',
        noOptions: 'Nenhum usuário encontrado com esse nome',
        buttons: {
          ok: 'Transferir',
          cancel: 'Cancelar'
        }
      },
      transferWhenClosingModal: {
        title: 'Transferir ao Finalizar',
        message:
          'Este atendimento tem outros atendentes. Deseja finalizar para todos ou transferir ?',
        selectAttendant: 'Selecione um atendente vinculado',
        buttons: {
          transfer: 'Transferir',
          close: 'Finalizar',
          cancel: 'Cancelar'
        }
      },
      ticketsList: {
        pendingHeader: 'Aguardando',
        assignedHeader: 'Atendendo',
        noTicketsTitle: 'Nada aqui!',
        noTicketsMessage:
          'Nenhum atendimento encontrado com esse status ou termo pesquisado',
        buttons: {
          accept: 'Aceitar'
        }
      },
      newTicketModal: {
        title: 'Criar Ticket',
        fieldLabel: 'Digite para pesquisar o contato',
        add: 'Adicionar',
        buttons: {
          ok: 'Salvar',
          cancel: 'Cancelar'
        }
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          connections: 'Conexões',
          tickets: 'Atendimentos',
          quickMessages: 'Respostas Rápidas',
          contacts: 'Contatos',
          contactFiles: 'Arquivos de Contatos',
          queues: 'Bot',
          tags: 'Tags',
          tasks: 'Tarefas',
          reminders: 'Lembretes',
          administration: 'Administração',
          service: 'Atendimento',
          users: 'Usuários',
          settings: 'Configurações',
          helps: 'Ajuda',
          messagesAPI: 'API',
          schedules: 'Agendamentos',
          campaigns: 'Campanhas',
          annoucements: 'Informativos',
          chats: 'Chat Interno',
          financeiro: 'Financeiro',
          logout: 'Sair',
          management: 'Gerência',
          kanban: 'Kanban'
        },
        appBar: {
          i18n: {
            language: 'Português',
            language_short: 'PT',
            language_description: 'Português (Brasil)'
          },
          user: {
            profile: 'Perfil',
            darkmode: 'Modo escuro',
            lightmode: 'Modo claro',
            language: 'Selecionar idioma',
            description:
              'Seu sistema será exibido conforme o idioma selecionado.',
            about: 'Sobre',
            logout: 'Sair'
          }
        }
      },
      messagesAPI: {
        title: 'API',
        textMessage: {
          number: 'Número',
          body: 'Mensagem',
          token: 'Token cadastrado'
        },
        mediaMessage: {
          number: 'Número',
          body: 'Nome do arquivo',
          media: 'Arquivo',
          token: 'Token cadastrado'
        }
      },
      notifications: {
        noTickets: 'Nenhuma notificação.'
      },
      quickMessages: {
        title: 'Respostas Rápidas',
        buttons: {
          add: 'Nova Resposta'
        },
        dialog: {
          shortcode: 'Atalho',
          message: 'Resposta'
        }
      },
      kanban: {
        title: 'Kanban',
        searchPlaceholder: 'Pesquisa',
        subMenus: {
          list: 'Painel',
          tags: 'Lanes'
        }
      },
      tagsKanban: {
        title: 'Lanes',
        laneDefault: 'Em aberto',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir esta Lane?',
          deleteMessage: 'Esta ação não pode ser revertida.'
        },
        table: {
          name: 'Nome',
          color: 'Cor',
          tickets: 'Tickets',
          actions: 'Ações'
        },
        buttons: {
          add: 'Nova Lane'
        },
        toasts: {
          deleted: 'Lane excluída com sucesso.'
        }
      },
      contactLists: {
        title: 'Listas de Contatos',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ações'
        },
        buttons: {
          add: 'Nova Lista'
        },
        dialog: {
          name: 'Nome',
          company: 'Empresa',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar'
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.'
        },
        toasts: {
          deleted: 'Registro excluído',
          created: 'Registro criado'
        }
      },
      contactListItems: {
        title: 'Contatos',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Novo',
          lists: 'Listas',
          import: 'Importar'
        },
        dialog: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar'
        },
        table: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          actions: 'Ações'
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
          importMessage: 'Deseja importar os contatos desta planilha? ',
          importTitlte: 'Importar'
        },
        toasts: {
          deleted: 'Registro excluído'
        }
      },
      common: {
        add: 'Adicionar'
      },
      campaigns: {
        title: 'Campanhas',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Nova Campanha',
          contactLists: 'Listas de Contatos'
        },
        table: {
          name: 'Nome',
          whatsapp: 'Conexão',
          contactList: 'Lista de Contatos',
          status: 'Status',
          scheduledAt: 'Agendamento',
          completedAt: 'Concluída',
          confirmation: 'Confirmação',
          actions: 'Ações'
        },
        dialog: {
          new: 'Nova Campanha',
          update: 'Editar Campanha',
          readonly: 'Apenas Visualização',
          form: {
            name: 'Nome',
            message1: 'Mensagem 1',
            message2: 'Mensagem 2',
            message3: 'Mensagem 3',
            message4: 'Mensagem 4',
            message5: 'Mensagem 5',
            confirmationMessage1: 'Mensagem de Confirmação 1',
            confirmationMessage2: 'Mensagem de Confirmação 2',
            confirmationMessage3: 'Mensagem de Confirmação 3',
            confirmationMessage4: 'Mensagem de Confirmação 4',
            confirmationMessage5: 'Mensagem de Confirmação 5',
            messagePlaceholder: 'Conteúdo da mensagem',
            whatsapp: 'Conexão',
            status: 'Status',
            scheduledAt: 'Agendamento',
            confirmation: 'Confirmação',
            contactList: 'Lista de Contato'
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar Disparos',
            restart: 'Reiniciar Disparos',
            close: 'Fechar',
            attach: 'Anexar Arquivo'
          }
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.'
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          cancel: 'Campanha cancelada',
          restart: 'Campanha reiniciada',
          deleted: 'Registro excluído'
        }
      },
      announcements: {
        title: 'Informativos',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Novo Informativo',
          contactLists: 'Listas de Informativos'
        },
        table: {
          priority: 'Prioridade',
          title: 'Title',
          text: 'Texto',
          mediaName: 'Arquivo',
          status: 'Status',
          actions: 'Ações'
        },
        dialog: {
          edit: 'Edição de Informativo',
          add: 'Novo Informativo',
          update: 'Editar Informativo',
          readonly: 'Apenas Visualização',
          form: {
            priority: 'Prioridade',
            title: 'Título',
            text: 'Descrição',
            mediaPath: 'Arquivo',
            status: 'Status'
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar',
            close: 'Fechar',
            attach: 'Anexar Arquivo'
          }
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você está prestes a excluir um informativo. Esta ação não pode ser revertida.'
        },
        toasts: {
          success: 'Informativo salvo com sucesso!',
          deleted: 'Informativo excluído com sucesso!'
        }
      },
      campaignsConfig: {
        title: 'Configurações de Campanhas'
      },
      queues: {
        title: 'Bot',
        table: {
          name: 'Nome',
          color: 'Cor',
          greeting: 'Mensagem de saudação',
          actions: 'Ações'
        },
        buttons: {
          add: 'Adicionar departamento'
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você tem certeza? Essa ação não pode ser revertida! Os atendimentos deste departamento continuarão existindo, mas não terão mais nenhum departamento atribuído.'
        }
      },
      queueSelect: {
        inputLabel: 'Departamentos'
      },
      users: {
        title: 'Usuários',
        table: {
          name: 'Nome',
          email: 'Email',
          profile: 'Perfil',
          actions: 'Ações'
        },
        buttons: {
          add: 'Adicionar usuário'
        },
        toasts: {
          deleted: 'Usuário excluído com sucesso.'
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Todos os dados do usuário serão perdidos. Os atendimentos abertos deste usuário serão movidos para o departamento.'
        }
      },
      helps: {
        title: 'Central de Ajuda'
      },
      about: {
        aboutthe: 'Sobre o',
        copyright: '© 2024 - Funcionando com ticketz',
        buttonclose: 'Fechar',
        title: 'Sobre o ticketz',
        abouttitle: 'Origem e melhorias',
        aboutdetail:
          'O ticketz é derivado indireto do projeto Whaticket com melhorias compartilhadas pelos desenvolvedores do sistema EquipeChat através do canal VemFazer no youtube, posteriormente melhoradas por Claudemir Todo Bom',
        aboutauthorsite: 'Site do autor',
        aboutwhaticketsite: 'Site do Whaticket Community no Github',
        aboutvemfazersite: 'Site do canal Vem Fazer no Github',
        licenseheading: 'Licença em Código Aberto',
        licensedetail:
          'O ticketz está licenciado sob a GNU Affero General Public License versão 3, isso significa que qualquer usuário que tiver acesso a esta aplicação tem o direito de obter acesso ao código fonte. Mais informações nos links abaixo:',
        licensefulltext: 'Texto completo da licença',
        licensesourcecode: 'Código fonte do ticketz',
        dependenciesheading: 'Dependências de Software',
        dependenciesdetail:
          'Este sistema utiliza os seguintes projetos de código aberto como dependências. Agradecemos a todos os mantenedores e contribuidores:',
        dependenciesTableName: 'Projeto',
        dependenciesTableVersion: 'Versão',
        dependenciesTableLicense: 'Licença'
      },
      schedules: {
        title: 'Agendamentos',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir este Agendamento?',
          deleteMessage: 'Esta ação não pode ser revertida.'
        },
        table: {
          contact: 'Contato',
          body: 'Mensagem',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          status: 'Status',
          actions: 'Ações'
        },
        buttons: {
          add: 'Novo Agendamento'
        },
        toasts: {
          deleted: 'Agendamento excluído com sucesso.'
        }
      },
      tags: {
        title: 'Tags',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir esta Tag?',
          deleteMessage: 'Esta ação não pode ser revertida.'
        },
        table: {
          name: 'Nome',
          color: 'Cor',
          tickets: 'Registros',
          actions: 'Ações',
          id: 'Id',
          kanban: 'Kanban'
        },
        buttons: {
          add: 'Nova Tag'
        },
        toasts: {
          deleted: 'Tag excluído com sucesso.'
        }
      },
      tasks: {
        title: 'Tarefas',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir esta Tarefa?',
          deleteMessage: 'Esta ação não pode ser revertida.'
        },
        table: {
          title: 'Título',
          contact: 'Contato',
          user: 'Atendente',
          priority: 'Prioridade',
          dueDate: 'Vencimento',
          description: 'Descrição',
          actions: 'Ações',
          id: 'Id',
          createdAt: 'Criado em'
        },
        buttons: {
          add: 'Nova Tarefa'
        },
        priority: {
          baixa: 'Baixa',
          media: 'Média',
          alta: 'Alta'
        },
        toasts: {
          deleted: 'Tarefa excluída com sucesso.',
          updated: 'Tarefa atualizada com sucesso.',
          created: 'Tarefa criada com sucesso.'
        },
        form: {
          title: 'Título da tarefa',
          description: 'Descrição',
          contact: 'Contato',
          user: 'Atendente',
          priority: 'Prioridade',
          dueDate: 'Data de vencimento',
          tags: 'Tags'
        }
      },
      whitelabel: {
        primaryColorLight: 'Cor primária clara',
        primaryColorDark: 'Cor primária escura',
        lightLogo: 'Logo do app claro',
        darkLogo: 'Logo do app escuro',
        favicon: 'Favicon do app',
        appname: 'Nome do app',
        logoHint: 'Prefira SVG e aspecto de 28:10',
        faviconHint: 'Prefira imagem SVG quadrada ou PNG 512x512',
        buildExtension: 'Gerar extensão WA Session Capture',
        buildingExtension: 'Gerando extensão…',
        downloadExtension: 'Baixar extensão',
        extensionHint:
          'Gera uma extensão Chrome whitelabel. O ZIP baixado já contém os arquivos da extensão: extraia e carregue a pasta extraída como extensão descompactada.',
        extensionBuildStarted:
          'Geração da extensão iniciada. Você será notificado quando estiver pronta.',
        extensionBuildFailed: 'Não foi possível iniciar a geração da extensão.',
        extensionBuilt: 'Extensão gerada com sucesso.',
        extensionBuildUnknownError: 'Erro desconhecido na geração.'
      },
      settings: {
        group: {
          general: 'Mensagens',
          timeouts: 'Ações do Atendimento',
          officeHours: 'Horário de expediente',
          groups: 'Grupos',
          confidenciality: 'Confidencialidade',
          api: 'API',
          serveradmin: 'Administração do servidor'
        },
        success: 'Configurações salvas com sucesso.',
        copiedToClipboard: 'Copiado para a área de transferência',
        title: 'Configurações',
        serverClock: {
          label: 'Horário do servidor',
          unavailable: 'Indisponível'
        },
        tabs: {
          general: 'Geral',
          dependencies: 'Dependências'
        },
        dependencies: {
          title: 'Dependências de Software',
          description:
            'Este sistema utiliza os seguintes projetos de código aberto. Agradecemos a todos os mantenedores e contribuidores.',
          notAvailable: 'Informações de dependências não disponíveis.',
          systemVersion: 'Versão do sistema',
          tagName: 'Tag name',
          totalDependencies: 'Total de dependências',
          generatedAt: 'Gerado em',
          tableName: 'Projeto',
          tableVersion: 'Versão',
          tableLicense: 'Licença'
        },
        settings: {
          userCreation: {
            name: 'Criação de usuário',
            options: {
              enabled: 'Ativado',
              disabled: 'Desativado'
            }
          }
        },
        validations: {
          title: 'Avaliações',
          options: {
            enabled: 'Habilitado',
            disabled: 'Desabilitado'
          }
        },
        OfficeManagement: {
          title: 'Gerenciamento de Expediente',
          options: {
            disabled: 'Desabilitado',
            ManagementByDepartment: 'Departamento',
            ManagementByCompany: 'Empresa'
          }
        },
        outOfHoursAction: {
          title: 'Ação fora do expediente',
          options: {
            pending: 'Deixar como pendente',
            ask: 'Perguntar para o contato',
            automatic: 'Automático (manter departamento atual)',
            closed: 'Fechar atendimento'
          }
        },
        IgnoreGroupMessages: {
          title: 'Ignorar Mensagens de Grupos',
          options: {
            enabled: 'Ativado',
            disabled: 'Desativado'
          }
        },
        soundGroupNotifications: {
          title: 'Notificações de som de grupo',
          options: {
            enabled: 'Ativado',
            disabled: 'Desativado'
          }
        },
        groupsTab: {
          title: 'Aba de Grupos',
          options: {
            enabled: 'Ativado',
            disabled: 'Desativado'
          }
        },
        VoiceAndVideoCalls: {
          title: 'Chamadas de Voz e Vídeo',
          options: {
            enabled: 'Ignorar',
            disabled: 'informar indisponibilidade'
          }
        },
        AutomaticChatbotOutput: {
          title: 'Saída automática do Bot',
          options: {
            enabled: 'Activado',
            disabled: 'Desativado'
          }
        },
        QuickMessages: {
          title: 'Mensagens Rápidas',
          options: {
            enabled: 'Por empresa',
            disabled: 'Por Usuário'
          }
        },
        ShowNumericEmoticons: {
          title: 'Mostrar Emoji Numéricos',
          options: {
            enabled: 'Ativado',
            disabled: 'Desativado'
          }
        },
        showSignatureButton: {
          title: 'Exibir Botão de Assinatura',
          options: {
            enabled: 'Habilitado',
            disabled: 'Desabilitado'
          }
        },
        AllowRegistration: {
          title: 'Permitir cadastro',
          options: {
            enabled: 'Ativado',
            disabled: 'Desativado'
          }
        },
        FileDownloadLimit: {
          title: 'Limite de Download de arquivos (MB)'
        },
        messageVisibility: {
          title: 'Visibilidade da mensagem',
          options: {
            respectMessageQueue: 'Respeitar departamento da mensagem',
            respectTicketQueue: 'Respeitar departamento do atendimento'
          }
        },
        keepQueueAndUser: {
          title: 'Manter departamento e usuário no atendimento fechado',
          options: {
            enabled: 'Ativado',
            disabled: 'Desativado'
          }
        },
        requireClosingReason: {
          title: 'Exigir o Assunto ao Finalizar o Atendimento',
          options: {
            enabled: 'Habilitado',
            disabled: 'Desabilitado'
          }
        },
        contactTicketHistory: {
          title: 'Histórico de atendimentos do contato'
        },
        WelcomeGreeting: {
          greetings: 'Olá',
          welcome: 'Seja bem-vindo a',
          expirationTime: 'Ativo até'
        },
        Options: {
          title: 'Geral'
        },
        SystemMessages: {
          title: 'Mensagens Padrões'
        },
        Companies: {
          title: 'Empresas'
        },
        schedules: {
          title: 'Horários'
        },
        Plans: {
          title: 'Planos'
        },
        Help: {
          title: 'Ajuda'
        },
        Whitelabel: {
          title: 'Whitelabel'
        },
        PaymentGateways: {
          title: 'Payment gateways'
        },
        notificationResetStartDate: {
          title: 'Hora Inicial de Reset de Notificação'
        },
        notificationResetEndDate: {
          title: 'Hora Final de Reset de Notificação'
        },
        dailyTicketReset: {
          title: 'Reset diário de atendimentos',
          options: {
            enabled: 'Habilitado',
            disabled: 'Desabilitado'
          }
        },
        outOfHoursInactiveTimeout: {
          title: 'Timeout fora do expediente (minutos)'
        },
        systemMessages: {
          description:
            'Edite os textos padrões usados pelo sistema quando não houver mensagem específica no departamento ou conexão.',
          outOfHoursMessage: 'Mensagem padrão de fora do horário',
          askContactApelidoMessage:
            'Mensagem para identificar com quem estamos falando',
          askContactNameMessage: 'Mensagem para pedir nome corretamente',
          openTicketTimeoutWarningMessage:
            'Mensagem de aviso de atendimento perto do limite',
          buttons: {
            save: 'Salvar mensagens'
          }
        }
      },
      messagesList: {
        header: {
          assignedTo: 'Atribuído à:',
          buttons: {
            return: 'Retornar',
            resolve: 'Resolver',
            reopen: 'Reabrir',
            accept: 'Aceitar',
            tag: 'Tag',
            transfer: 'Transferir',
            schedule: 'Agendamento',
            selectQueue: 'Selecione',
            leaveAttendance: 'Sair do atendimento'
          }
        }
      },
      messagesInput: {
        placeholderOpen: 'Digite uma mensagem',
        placeholderClosed:
          'Reabra ou aceite esse atendimento para enviar uma mensagem.',
        signMessage: 'Assinar',
        replying: 'Respondendo',
        editing: 'Editando'
      },
      message: {
        edited: 'Editada',
        forwarded: 'Encaminhada'
      },

      contactDrawer: {
        header: 'Dados do contato',
        buttons: {
          edit: 'Editar contato'
        },
        extraInfo: 'Outras informações'
      },
      ticketOptionsMenu: {
        schedule: 'Agendamento',
        delete: 'Deletar',
        transfer: 'Transferir',
        close: 'Finalizar Atendimento',
        registerAppointment: 'Observações do Contato',
        appointmentsModal: {
          title: 'Observações do Contato',
          textarea: 'Observação',
          placeholder: 'Insira aqui a informação que deseja registrar'
        },
        confirmationModal: {
          title: 'Deletar o atebdimento do contato',
          message:
            'Atenção! Todas as mensagens relacionadas ao atendimento serão perdidas.'
        },
        buttons: {
          delete: 'Excluir',
          cancel: 'Cancelar'
        }
      },
      confirmationModal: {
        buttons: {
          confirm: 'Ok',
          cancel: 'Cancelar'
        }
      },
      messageOptionsMenu: {
        delete: 'Deletar',
        edit: 'Editar',
        forward: 'Encaminhar',
        history: 'Histórico',
        reply: 'Responder',
        replyBot: 'Responder Bot',
        confirmationModal: {
          title: 'Apagar mensagem?',
          message: 'Esta ação não pode ser revertida.'
        }
      },
      messageHistoryModal: {
        close: 'Fechar',
        title: 'Histórico de edição da mensagem'
      },
      presence: {
        unavailable: 'Indisponível',
        available: 'Disponível',
        composing: 'Digitando...',
        recording: 'Gravando...',
        paused: 'Pausado'
      },
      privacyModal: {
        title: 'Editar Privacidade do Whatsapp',
        buttons: {
          cancel: 'Cancelar',
          okEdit: 'Salvar'
        },
        form: {
          menu: {
            all: 'Todos',
            none: 'Ninguém',
            contacts: 'Meus contatos',
            contact_blacklist: 'Contatos selecionados',
            match_last_seen: 'Semelhante ao Visto por Último',
            known: 'Conhecidos',
            disable: 'Desativada',
            hrs24: '24 Horas',
            dias7: '7 Dias',
            dias90: '90 Dias'
          },
          readreceipts: 'Recibos de leitura',
          profile: 'Foto do perfil',
          status: 'Recados',
          online: 'Online',
          last: 'Último Visto',
          groupadd: 'Adicionar a grupos',
          calladd: 'Adicionar a Ligações',
          disappearing: 'Modo de Desaparecimento Padrão'
        }
      },
      connectionAlertModal: {
        title: 'Configurar alerta de desconexão',
        enabledLabel: 'Ativar envio de e-mails',
        intervalLabel: 'Intervalo para confirmar desconexão',
        intervals: {
          '30s': '30 segundos',
          '1m': '1 minuto',
          '2m': '2 minutos'
        },
        emailsTitle: 'E-mails de alerta',
        newEmailLabel: 'Novo e-mail',
        add: 'Adicionar',
        edit: 'Editar',
        save: 'Salvar',
        cancel: 'Cancelar',
        delete: 'Excluir',
        close: 'Fechar',
        intervalSaved: 'Intervalo salvo com sucesso!',
        emailAdded: 'E-mail adicionado com sucesso!',
        emailUpdated: 'E-mail atualizado com sucesso!',
        emailDeleted: 'E-mail removido com sucesso!',
        invalidEmail: 'Informe um e-mail válido.',
        confirmDelete: 'Tem certeza que deseja excluir este e-mail?',
        enabled: 'Envio de e-mails ativado.',
        disabled: 'Envio de e-mails desativado.'
      },
      backendErrors: {
        ERR_FORBIDDEN: 'Você não tem permissão para acessar este recurso.',
        ERR_CHECK_NUMBER: 'Verifique o número e tente novamente.',
        ERR_NO_OTHER_WHATSAPP: 'Deve haver pelo menos um WhatsApp padrão.',
        ERR_NO_DEF_WAPP_FOUND:
          'Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.',
        ERR_WAPP_NOT_INITIALIZED:
          'Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.',
        ERR_WAPP_CHECK_CONTACT:
          'Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões',
        ERR_WAPP_INVALID_CONTACT: 'Este não é um número de Whatsapp válido.',
        ERR_WAPP_DOWNLOAD_MEDIA:
          'Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.',
        ERR_LOGIN_ACCESS_DENIED:
          'Não foi possível realizar o acesso. Verifique suas credenciais ou contate seu gestor. O acesso pode estar restrito por horário ou status da conta.',
        ERR_INVALID_CREDENTIALS:
          'Erro de autenticação. Por favor, tente novamente.',
        ERR_USER_INACTIVE:
          'Seu usuário está inativo. Entre em contato com o administrador.',
        ERR_OUT_OF_WORK_SCHEDULE:
          'Acesso fora do horario de expediente permitido para este usuario.',
        ERR_SENDING_WAPP_MSG:
          'Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.',
        ERR_DELETE_WAPP_MSG: 'Não foi possível excluir a mensagem do WhatsApp.',
        ERR_EDITING_WAPP_MSG: 'Não foi possível editar a mensagem do WhatsApp.',
        ERR_OTHER_OPEN_TICKET: 'Já existe um atendimento aberto para este contato.',
        ERR_EMAIL_IN_USE: 'O e-mail informado já está em uso por outra empresa.',
        ERR_COMPANY_NAME_ALREADY_EXISTS: 'Já existe uma empresa cadastrada com este nome.',
        ERR_COMPANY_EMAIL_ALREADY_EXISTS: 'Já existe uma empresa cadastrada com este e-mail comercial.',
        ERR_COMPANY_INVALID_NAME: 'O nome da empresa informado não é válido.',
        ERR_SESSION_EXPIRED: 'Sessão expirada. Por favor entre.',
        ERR_USER_CREATION_DISABLED:
          'A criação do usuário foi desabilitada pelo administrador.',
        ERR_NO_PERMISSION: 'Você não tem permissão para acessar este recurso.',
        ERR_DUPLICATED_CONTACT: 'Já existe um contato com este número.',
        ERR_NO_SETTING_FOUND: 'Nenhuma configuração encontrada com este ID.',
        ERR_NO_CONTACT_FOUND: 'Nenhum contato encontrado com este ID.',
        ERR_NO_TICKET_FOUND: 'Nenhum tíquete encontrado com este ID.',
        ERR_NO_USER_FOUND: 'Nenhum usuário encontrado com este ID.',
        ERR_NO_WAPP_FOUND: 'Nenhum WhatsApp encontrado com este ID.',
        ERR_CREATING_MESSAGE: 'Erro ao criar mensagem no banco de dados.',
        ERR_CREATING_TICKET: 'Erro ao criar tíquete no banco de dados.',
        ERR_FETCH_WAPP_MSG:
          'Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          'Esta cor já está em uso, escolha outra.',
        ERR_WAPP_GREETING_REQUIRED:
          'A mensagem de saudação é obrigatória quando há mais de um departamento.',
        'Acesso não permitido. Você precisa estar associado a pelo menos um departamento ou ter permissões adequadas para acessar os atendimentos.':
          'Acesso não permitido. Você precisa estar associado a pelo menos um departamento ou ter permissões adequadas para acessar os atendimentos. Entre em contato com o administrador.'
      },
      ticketz: {
        registration: {
          header: 'Cadastre-se na base de usuários do Ticketz',
          description:
            'Preencha os campos abaixo para se cadastrar na base de usuários do Ticketz e receber novidades sobre o projeto.',
          name: 'Nome',
          country: 'País',
          phoneNumber: 'Número de Whatsapp',
          submit: 'Cadastrar'
        },
        support: {
          title: 'Apoie o projeto Ticketz Open Source',
          mercadopagotitle: 'Cartão de Crédito',
          recurringbrl: 'Doação recorrente em R$',
          paypaltitle: 'Cartão de Crédito',
          international: 'Internacional em US$'
        }
      },
      closingReasonModal: {
        title: 'Motivo da Finalização',
        subtitle: 'Selecione o motivo para finalizar este atendimento:',
        selectLabel: 'Motivo da Finalização',
        selectHelper: 'Escolha um motivo antes de confirmar',
        description: 'Descrição',
        cancel: 'Cancelar',
        confirm: 'Finalizar Atendimento',
        createNew: 'Criar Novo',
        success: 'Motivo salvo com sucesso!',
        titleClosingReason: {
          add: 'Novo Motivo de Finalização',
          edit: 'Editar Motivo de Finalização'
        },
        form: {
          name: 'Nome do Motivo',
          nameRequired: 'Nome é obrigatório',
          description: 'Descrição',
          active: 'Ativo',
          departments: 'Departamentos Vinculados'
        },
        buttons: {
          cancel: 'Cancelar',
          okAdd: 'Adicionar',
          okEdit: 'Salvar'
        }
      },
      closingReasons: {
        title: 'Motivos de Finalização',
        buttons: {
          add: 'Adicionar'
        },
        table: {
          id: 'ID',
          name: 'Nome',
          description: 'Descrição',
          departments: 'Departamentos',
          status: 'Status',
          actions: 'Ações',
          active: 'Ativo',
          inactive: 'Inativo'
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.'
        },
        toasts: {
          deleted: 'Motivo excluído com sucesso.'
        }
      },
      clientes: {
        title: 'Clientes',
        searchPlaceholder: 'Pesquisar...',
        buttons: {
          add: 'Adicionar Cliente'
        },
        table: {
          name: 'Nome',
          cpfCnpj: 'CPF/CNPJ',
          tipo: 'Tipo',
          segmento: 'Segmento',
          actions: 'Ações'
        },
        confirmationModal: {
          deleteTitle: 'Excluir cliente',
          deleteMessage: 'Tem certeza? Esta ação não pode ser revertida.'
        },
        toasts: {
          deleted: 'Cliente excluído com sucesso.'
        }
      },
      clienteModal: {
        title: {
          add: 'Adicionar Cliente',
          edit: 'Editar Cliente'
        },
        form: {
          nome: 'Nome',
          cpfCnpj: 'CPF/CNPJ',
          tipo: 'Tipo',
          segmento: 'Segmento'
        },
        buttons: {
          cancel: 'Cancelar',
          okAdd: 'Adicionar',
          okEdit: 'Salvar'
        },
        success: {
          create: 'Cliente criado com sucesso!',
          update: 'Cliente atualizado com sucesso!'
        }
      }
    }
  }
}

export { messages }
